import { RootState } from "..";

export const selectPolls = (state:RootState) => state.polls.polls;
export const selectSelectedPoll = (state:RootState) => state.polls.selectedPoll;
export const selectTotal = (state:RootState) => state.polls.total;
export const selectParams = (state:RootState) => state.polls.params;
